"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.form = void 0;
const types_1 = require("../../types");
const project_section_1 = require("./sections/project.section");
const boundary_section_1 = require("./sections/boundary.section");
const engineer_section_1 = require("./sections/engineer.section");
const machine_directive_1 = require("./directives/machine.directive");
const manufacturer_section_1 = require("./sections/manufacturer.section");
const image_document_1 = require("./documents/image.document");
exports.form = {
    type: types_1.Certification.ukCa,
    sections: [
        // questionSection,
        project_section_1.default,
        engineer_section_1.default,
        manufacturer_section_1.default,
        boundary_section_1.default,
    ],
    directives: [machine_directive_1.default],
    documents: [image_document_1.default],
};
